import { render } from "./MotivoCita.vue?vue&type=template&id=107d66f8"
import script from "./MotivoCita.vue?vue&type=script&lang=js"
export * from "./MotivoCita.vue?vue&type=script&lang=js"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__